import { CheckboxGroupInput } from "react-admin";
import FormModal from "server/components/Modals/FormModal";

const COURSE_YEARS = Array.from({ length: 12 }, (_, index) => ({ id: index + 1, name: String(index + 1) }));

// The years of a cycle are picked together, so the same year can't be added twice.
const CourseYearsDialog = ({ years, onSave, triggerButton }) => (
  <FormModal
    titleContent="Редакция · курсове"
    triggerButton={triggerButton}
    defaultValues={{ years }}
    saveTitle="Запази"
    onConfirm={data => onSave([...(data.years ?? [])].sort((a, b) => a - b))}
  >
    <CheckboxGroupInput
      source="years"
      label="Курс"
      choices={COURSE_YEARS}
    />
  </FormModal>
);

export default CourseYearsDialog;
